// extracted by mini-css-extract-plugin
export default {"head":"List_head__Q-FZI","headMain":"List_headMain__5I1d0","pad0":"List_pad0__hWWXD","btntbl":"List_btntbl__1qTKq","id":"List_id__9uS2j","btns":"List_btns__IWqm7"};